import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './i18n/config.js'; // Initialize i18next
import App from './App.jsx';
import { registerChunkLoadRecovery } from './utils/chunkLoadRecovery.js';

registerChunkLoadRecovery();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
